module.exports = __webpack_public_path__ + "static/img/update-password.78722ebe.png";